import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Notification } from '../interfaces/notification.interface';
import { DateTime } from 'luxon';
import { trackById } from 'src/@vex/utils/track-by';
import { VexDateFormatRelativePipe } from 'src/@vex/pipes/vex-date-format-relative/vex-date-format-relative.pipe';
import { Router, RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { CommonModule, NgClass, NgFor } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { VexPopoverService } from 'src/@vex/components/vex-popover/vex-popover.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import Swal from 'sweetalert2';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationStateService } from '../notification-shared-service.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { VexPopoverRef } from 'src/@vex/components/vex-popover/vex-popover-ref';
import { NotificationType } from 'src/assets/static-data/enums/notification-types';
import { NotificationOperation } from 'src/assets/static-data/enums/notification-operation';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'vex-toolbar-notifications-dropdown',
  templateUrl: './toolbar-notifications-dropdown.component.html',
  styleUrls: ['./toolbar-notifications-dropdown.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    NgFor,
    MatRippleModule,
    RouterLink,
    VexDateFormatRelativePipe,
    TranslateModule,
    CommonModule
  ]
})
export class ToolbarNotificationsDropdownComponent implements OnInit {
  unReadCount: number = 0;
  notifications = new BehaviorSubject<any[]>(null);
  notificationTotalCount: number = 0; // Initialize to 0
  index = 0;
  numberOfPages: number;
  environmentType=environment.portalType;
  trackById = trackById;
  currentUserId: string;
  notificationCount$: Observable<number>;
  notificationType=NotificationType;
  notificationOperation=NotificationOperation;
  navigationRoute:string;
  constructor(
    private router: Router,
    private cd: ChangeDetectorRef,
    private notificationService: NotificationService,
    private authService: AuthService,
    private popOverRef: VexPopoverRef<any>,

  ) {}

  ngOnInit() {
    this.getUserNotifications();
    //this.loadNotifications();
  }

  loadNotifications() {
    this.notificationService.getNotifications().subscribe({
      next: (response) => {
        // debugger
        this.notifications.next(response.data.notifications);
        this.notificationTotalCount = response.data.count; // Set total count
        this.numberOfPages = Math.floor(this.notificationTotalCount / 30);
        this.cd.markForCheck(); // Trigger change detection
      },
      error: (err) => console.error('Error loading notifications:', err),
    });
  }

  getUserNotifications()
  {
    this.currentUserId = this.authService.currentUserValue.id;
  
    this.notificationService.getUserNotifications(this.currentUserId).subscribe({
      next: (response) => {
        // debugger
        this.notifications.next(response.data.notifications);
        this.notificationTotalCount = response.data.count; // Set total count
        this.numberOfPages = Math.floor(this.notificationTotalCount / 30);
        this.cd.markForCheck(); // Trigger change detection
      },
      error: (err) => console.error('Error loading notifications:', err),
    });

}


readAllNotifications()
{
   this.currentUserId = this.authService.currentUserValue.id;
  this.notificationService.readAllNotifications(this.currentUserId).subscribe((response: any) => {
    if(response.statusCode == 200){
      Swal.fire("Notifications Readed Successfully", "", "success");
      // // debugger;
      
      this.notificationCount$ = this.notificationService.notificationCount$;
      this.notificationService.getNotifications().subscribe(response => {
        this.notifications.next(response.data.notifications);
      });
    }
  })

}
// readAllNotifications() {
//   const userId = this.authService.currentUserValue.id;

//   this.notificationService.readAllNotifications(userId).subscribe((response: any) => {
//     if (response.statusCode === 200) {
//       Swal.fire('Notification Read Successfully', '', 'success').then(() => {
//         this.unReadCount = 0;
//         this.popOverRef.close({ data: { unreadCount: 0 } }); 
//       });
//     }
//   });
// }

LoadMoreNotifications(){
  this.notificationService.getNotifications(++this.index).subscribe(response => {
    this.notifications.next(this.notifications.getValue().concat(response.data.notifications));
  })
}



readOneNotification(notify)
{
  // debugger
  const navigationRoute={
    "SalesQuotation":'sales-quotation',
    "SalesOrder":'sales-orders',
    "PurchaseOrder":'purchase-orders',
    "LoadingOrder":this.environmentType=='main-portal'?'loading-order':'orders-tracking',
    "SalesDelivery":'sales-deliveries',
    "None":null,
    "Add":"/view",
    "Update":"/view",
    "Delete":null,
    "Completed":"/view"
  }
  const route=`/transactions/${navigationRoute[this.notificationType[notify.type]]}${navigationRoute[this.notificationOperation[notify.operation]]?navigationRoute[this.notificationOperation[notify.operation]]+'/'+notify.objectId:''}`;
  this.navigationRoute=route;   
  this.notificationService.readNotification(notify.id).subscribe(response=>{
 console.log(response);
});
}
}
